<div [ngClass]="IsValid ? 'ValidForm':'InvalidForm'">

    <!--(opened)="LgvExpPanelOpen = true;" (closed)="LgvExpPanelOpen = false"-->

    <mat-expansion-panel hideToggle [expanded]="IsExpanded" (opened)="OnExpansionChange(true)" (closed)="OnExpansionChange(false)">
        <mat-expansion-panel-header>
            <mat-panel-title>
                <div style="width:100%" style="display: flex; flex-direction: row; justify-content: space-between; width: 100%;">
                    <div class="left" style="display: flex; flex-direction: row;">
                        <div class="float-left" style="margin-top: 3px">
                            <fa-icon icon="chevron-circle-right" *ngIf="!IsExpanded"></fa-icon>
                            <fa-icon icon="chevron-circle-down" *ngIf="IsExpanded"></fa-icon>
                        </div>
                        <div class="float-left ExpanderHeaderTitle">
                            <ng-content select="[headerTitle]"></ng-content>
                        </div>
                    </div>
                    <div class="right" style="display: flex; flex-direction: row;">
                        <div class="float-end ExpanderHeaderRight">
                            <ng-content select="[headerRight]"></ng-content>
                        </div>
                        <div class="clear:both;"></div>
                    </div>
                </div>
            </mat-panel-title>
        </mat-expansion-panel-header>

        <div class="row">
            <div class="col-12 ExpanderBody">
                <ng-content select="[body]"></ng-content>
            </div>
        </div>

        <div class="row">
            <div class="col-12">
                <ng-content select="[headerRight]"></ng-content>
            </div>
        </div>

    </mat-expansion-panel>
</div>
